import { render, staticRenderFns } from "./calidad-e-innovacion.vue?vue&type=template&id=449b400d"
import script from "./calidad-e-innovacion.vue?vue&type=script&lang=js"
export * from "./calidad-e-innovacion.vue?vue&type=script&lang=js"
import style0 from "./calidad-e-innovacion.vue?vue&type=style&index=0&id=449b400d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports